var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoVerde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9224",
    "data-name": "Group 9224",
    transform: "translate(690 -454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13491",
    "data-name": "Rectangle 13491",
    width: 65,
    height: 67,
    rx: 32.5,
    transform: "translate(-690 454)",
    fill: "#00ca7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_13-car",
    "data-name": "13-car",
    transform: "translate(-679 478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M72.437,236a4.437,4.437,0,1,0,4.437,4.437A4.437,4.437,0,0,0,72.437,236Zm0,6.484a2.048,2.048,0,1,1,2.048-2.048A2.048,2.048,0,0,1,72.437,242.484Z",
    transform: "translate(-62.54 -224.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M360.437,236a4.437,4.437,0,1,0,4.436,4.437A4.437,4.437,0,0,0,360.437,236Zm0,6.484a2.048,2.048,0,1,1,2.048-2.048A2.048,2.048,0,0,1,360.437,242.484Z",
    transform: "translate(-325.968 -224.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M44.389,107.938l-7.969-1.454-6.784-5.629A3.763,3.763,0,0,0,27.251,100H17.257a3.736,3.736,0,0,0-2.931,1.409l-4.333,5.075H7.071A3.075,3.075,0,0,0,4,109.555v3.754a3.758,3.758,0,0,0,3.754,3.754h.78a5.46,5.46,0,1,1,10.725,0H33.106a5.46,5.46,0,1,1,10.725,0h.1A3.075,3.075,0,0,0,47,113.992v-3.017A3.054,3.054,0,0,0,44.389,107.938ZM19.016,105.46a1.024,1.024,0,0,1-1.024,1.024h-4.5a.512.512,0,0,1-.389-.845l2.979-3.489a1.024,1.024,0,0,1,.779-.358h1.133a1.024,1.024,0,0,1,1.024,1.024Zm5.119,4.778H22.77a1.024,1.024,0,1,1,0-2.048h1.365a1.024,1.024,0,1,1,0,2.048Zm8.061-3.729-9.769-.023a1.024,1.024,0,0,1-1.021-1.024v-2.647a1.024,1.024,0,0,1,1.024-1.024h4.91a1.024,1.024,0,0,1,.634.22l4.541,3.583a.512.512,0,0,1-.318.914Z",
    transform: "translate(-4 -100)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoVerde);
export default __webpack_public_path__ + "static/media/AutoVerde.761277b95ea83b07339aa7be652a8683.svg";
export { ForwardRef as ReactComponent };